import { useContext } from 'react';
import { AuthContext } from '@/context/AuthContext';

/**
 * Custom hook to access authentication context
 * @returns Authentication context with user state and auth methods
 */
export const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (context === null) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  // Ensure organizationId is always available, even as a fallback from metadata
  const organizationId = context.organizationId || 
    (context.user?.user_metadata?.organization_id as string | undefined);
  
  return {
    ...context,
    organizationId,
    subscriptionStatus: context.subscriptionStatus,
    hasValidSubscription: context.hasValidSubscription,
    refreshUser: context.refreshUser,
  };
};
